/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { Box, CircularProgress } from '@mui/material'
import { useState } from 'react'
import {
  AboutMe,
  Experience,
  LandingImage,
  Footer,
  Skills
} from '../components'

export const LandingPage = () => {
  const [loaded, setLoaded] = useState(false)

  return (
    <>
      <Box sx={{ bgcolor: 'background.default' }}>
        <a id='home' />
        <Box mt={8}/>
        <LandingImage setLoaded={setLoaded} />
        {loaded ? (
          <Box sx={{maxWidth: "lg", mx: "auto"}}>
            <AboutMe />
            <Skills />
            <Experience />
            <Footer />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              margin: 'auto',
              padding: '20vh',
              justifyContent: 'center'
            }}
          >
            <CircularProgress color='secondary'/>
          </Box>
        )}
      </Box>
    </>
  )
}

export default LandingPage
